/**
 * DbProductActionBar - 商品详情底部操作栏样式
 */
import { StyleSheet, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

/** 默认配置 */
export const ACTION_BAR_DEFAULTS = {
  height: 50,
  backgroundColor: '#ffffff',
  iconSize: 22,
  iconColor: '#999999',
  textColor: '#666666',
  buttonHeight: 36,
  borderRadius: 18,
  gap: 8,
  leftPadding: 12,
  rightPadding: 12,
  dividerColor: '#e0e0e0',
  // 默认按钮颜色
  primaryButtonColor: '#ff9500',
  secondaryButtonColor: '#FF2442',
  combinedButtonColor: '#FF2442',
} as const;

export const createStyles = (
  theme: 'light' | 'dark',
  height: number = ACTION_BAR_DEFAULTS.height,
  backgroundColor?: string,
  dividerColor?: string
) => {
  return StyleSheet.create({
    // 容器
    container: {
      width: width,
      height: height,
      backgroundColor: backgroundColor || ACTION_BAR_DEFAULTS.backgroundColor,
      flexDirection: 'row',
      alignItems: 'center',
      borderTopWidth: StyleSheet.hairlineWidth,
      borderTopColor: dividerColor || ACTION_BAR_DEFAULTS.dividerColor,
    },

    // 固定在底部
    fixedContainer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: backgroundColor || ACTION_BAR_DEFAULTS.backgroundColor,
    },

    // 左侧图标区域
    leftSection: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingLeft: ACTION_BAR_DEFAULTS.leftPadding,
      flex: 1,
    },

    // 图标按钮
    iconItem: {
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      maxWidth: 60,
    },

    // 图标容器（用于徽标定位）
    iconContainer: {
      position: 'relative',
    },

    // 图标文字
    iconText: {
      fontSize: 10,
      color: ACTION_BAR_DEFAULTS.textColor,
      marginTop: 2,
    },

    // 徽标
    badge: {
      position: 'absolute',
      top: -6,
      right: -8,
      minWidth: 16,
      height: 16,
      borderRadius: 8,
      backgroundColor: '#FF2442',
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 4,
    },

    // 徽标文字
    badgeText: {
      color: '#ffffff',
      fontSize: 10,
      fontWeight: '600',
    },

    // 右侧按钮区域
    rightSection: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingRight: ACTION_BAR_DEFAULTS.rightPadding,
      flex: 2,
    },

    // 分开模式 - 按钮容器
    separateContainer: {
      flexDirection: 'row',
      flex: 1,
      gap: ACTION_BAR_DEFAULTS.gap,
    },

    // 分开模式 - 按钮基础样式
    separateButton: {
      flex: 1,
      height: ACTION_BAR_DEFAULTS.buttonHeight,
      borderRadius: ACTION_BAR_DEFAULTS.borderRadius,
      justifyContent: 'center',
      alignItems: 'center',
    },

    // 分开模式 - 主按钮（加入购物车）
    primaryButton: {
      backgroundColor: ACTION_BAR_DEFAULTS.primaryButtonColor,
    },

    // 分开模式 - 次按钮（立即购买）
    secondaryButton: {
      backgroundColor: ACTION_BAR_DEFAULTS.secondaryButtonColor,
    },

    // 组合模式 - 容器
    combinedContainer: {
      flexDirection: 'row',
      height: ACTION_BAR_DEFAULTS.buttonHeight,
      borderRadius: ACTION_BAR_DEFAULTS.borderRadius,
      overflow: 'hidden',
    },

    // 组合模式 - 左按钮（加入购物车）
    combinedLeftButton: {
      flex: 1,
      backgroundColor: ACTION_BAR_DEFAULTS.primaryButtonColor,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 20,
    },

    // 组合模式 - 右按钮（立即购买）
    combinedRightButton: {
      flex: 1,
      backgroundColor: ACTION_BAR_DEFAULTS.secondaryButtonColor,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 20,
    },

    // 按钮文字
    buttonText: {
      color: '#ffffff',
      fontSize: 13,
      fontWeight: '600',
    },

    // 禁用状态
    disabled: {
      opacity: 0.5,
    },
  });
};
